import config from '@/utils/config'
import moment from 'moment'
import numbro from 'numbro'
import Vue from 'vue'

const filters = {
  staticPath: function (path) {
    let staticPath = config.staticPath || ''
    return staticPath + path
  },
  formatDate (momentDate) {
    return moment(momentDate).format(config.features.dateMask)
  },
  formatAmount (amount) {
    if (_.isObject(amount)) {
      return numbro(amount.quantity).format('0,0') + ' ' + amount.currency.toUpperCase()
    } else {
      return numbro(amount).format('0,0') + ' ' + config.features.defaultCurrency
    }
  },
  obtainTextOptionList(value, sourceDataList) {
    let sourceData = sourceDataList.find(item => item.id === value)
    let sourceDataText = !_.isUndefined(sourceData)
      ? sourceData.name
      : ''
    return sourceDataText
  },
  i18nList (list) {
    const i18nList = list.map(item => {
      return {
        item,
        text: Vue.i18n.translate(item.textKey)
      }
    })
    return i18nList
  }
}

export default filters
